// API Configuration
const API_CONFIG = {
    BASE_URL: process.env.REACT_APP_API_URL || "https://pbapi.paperbrainz.com" || "http://localhost:5001",
    SOCKET_URL: process.env.REACT_APP_SOCKET_URL || "https://pbapi.paperbrainz.com" || "http://localhost:5001",
    TIMEOUT: 10000, // 10 seconds
    RETRY_ATTEMPTS: 3,
    RETRY_DELAY: 1000, // 1 second
};

// API Endpoints
export const API_ENDPOINTS = {
    // Authentication
    AUTH: {
        LOGIN: "/api/auth/login",
        REGISTER: "/api/auth/register",
        LOGOUT: "/api/auth/logout",
        REFRESH: "/api/auth/refresh",
        ME: "/api/auth/me",
        FORGOT_PASSWORD: "/api/auth/forgot-password",
        RESET_PASSWORD: "/api/auth/reset-password",
        VERIFY_EMAIL: "/api/auth/verify-email",
        RESEND_VERIFICATION: "/api/auth/resend-verification",
        GOOGLE: "/api/auth/google",
    },

    // Dashboard
    DASHBOARD: {
        DATA: "/api/dashboard/data",
        METRICS: "/api/dashboard/metrics",
        CHART_DATA: "/api/dashboard/chart-data",
        ACTIVITIES: "/api/dashboard/activities",
        ANALYTICS: "/api/dashboard/analytics",
        STATS: "/api/dashboard/stats",
        REFRESH: "/api/dashboard/refresh",
    },

    // Users
    USERS: {
        PROFILE: "/api/users/profile",
        CHANGE_PASSWORD: "/api/users/change-password",
        SESSIONS: "/api/users/sessions",
        DEACTIVATE: "/api/users/deactivate",
    },

    // Widgets
    WIDGETS: {
        LIST: "/api/widgets",
        CREATE: "/api/widgets",
        GET: (id) => `/api/widgets/${id}`,
        UPDATE: (id) => `/api/widgets/${id}`,
        DELETE: (id) => `/api/widgets/${id}`,
        STATS: (id) => `/api/widgets/${id}/stats`,
        HISTORY: (id) => `/api/widgets/${id}/history`,
        STATUS: (id) => `/api/widgets/${id}/status`,
    },

    // Metrics
    METRICS: {
        LIST: "/api/metrics",
        CREATE: "/api/metrics",
        OVERVIEW: "/api/metrics/overview",
        COMPARATIVE: "/api/metrics/comparative",
        TOP_WIDGETS: "/api/metrics/top-widgets",
        HISTORY: (type) => `/api/metrics/${type}/history`,
        WIDGET: (widgetId) => `/api/metrics/widget/${widgetId}`,
        UPDATE_FROM_INTERACTIONS: "/api/metrics/update-from-interactions",
    },

    // Advanced Settings
    ADVANCED: {
        GET: "/api/advanced",
        UPDATE: "/api/advanced",
    },

    // Integration
    INTEGRATION: {
        CREDENTIALS: "/api/integration/credentials",
    },

    // Appearance
    APPEARANCE: {
        GET: "/api/appearance",
        SAVE: "/api/appearance/save",
    },

    // Public Widget
    PUBLIC: {
        WIDGET: (widgetId) => `/api/public/widget/${widgetId}`,
    },
};

export default API_CONFIG;